
export { ShoppingBagButton } from "/codebuild/output/src3632624141/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"